<template>
  <div>
    <dashboard-header :text='$t("schedule.caption")'/>

    <v-card
        elevation="0"
        class="card-border-10">

      <div class="d-flex pt-10 px-10">
        <div class="ms-auto me-4 mt-2 text-18px">{{ $t("base.filterByDepartment") }}</div>

        <div class="w-50">
          <v-select
              :loading="filterLoading"
              v-model="selectedFilter"
              :items="listFilter"
              :placeholder="$t('employee.selectDepartment')"
              v-on:change="customFilter"
              item-text="name"
              small-chips
              chips
              deletable-chips
              return-object
              dense
              outlined>

          </v-select>
        </div>

        <v-btn
            v-if="isCreate"
            outlined
            elevation="0"
            class="no-uppercase ml-2 btn-custom-import"
            @click="openImportDialog">
          {{ $t("schedule.import") }}
        </v-btn>

        <v-btn
            v-if="isCreate"
            elevation="0"
            class="no-uppercase btn-custom-primary ml-2"
            @click="addItem">
          <b-img
              class="mr-2"
              :src="require('@/assets/images/ic-plus.svg')"
              width="16"
              height="16"
          />
          {{ $t("base.create") }}
        </v-btn>
      </div>

      <schedule-table
          class="px-10"
          hideSearch
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :item-click="onItemTableClick"
          :edit="isEdit ? editItem : null"
          :on-delete="isDelete ? deleteItem : null"
          :get-items="getItems"
          :custom-total-rows="totalRows"
      />

    </v-card>

    <import-dialog
        v-model="showImportDialog"
        @imported="onImported"
    />

  </div>
</template>

<script>
import moment from "moment";
import {SCHEDULE_ACTION_TYPE, TYPE_FORMAT_TIME} from "../../config/constant";
import ScheduleTable from "./ScheduleTable";
import ImportDialog from "./ImportDialog";
import i18n from "../../lang/i18n";
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import mixin from "../../mixin";
import {PERMISSIONS} from "../../config/permissions";

export default {
  components: {DashboardHeader, ScheduleTable, ImportDialog},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      // table
      items: [],
      totalRows: 0,
      optionParams: null,
      filterLoading: false,
      labelFilterTable: i18n.t("base.filterByDepartment"),
      firstFilterTableLabel: i18n.t("base.allDepartments"),
      listFilter: [],
      selectedFilter: null,
      showImportDialog: false,
      allDepartmentsOption: { departmentId: null, name: i18n.t("base.allDepartments") },

    };
  },
  mounted() {
    this.onTab()
  },
  methods: {
    onTab() {
      this.getItems(this.optionParams)
      this.getListFilter()
    },
    async getItems(optionParams) {
      if (!optionParams) return
      optionParams.departmentId = this.selectedFilter ? this.selectedFilter.departmentId : null
      optionParams.sortBy = 'name';
      optionParams.orderBy = 'ASC';
      this.optionParams = optionParams

      let res = await this.get(API2.SCHEDULE_LIST, optionParams)
      // console.log("res", res)
      if (!res) return

      this.totalRows = res.total
      this.items = res.data.map(item => {
        item.scheduleInfo.map(schedule => {
          schedule.name = item.name
          schedule.departmentId = item.departmentId
          schedule.employeeId = item.employeeId
        })
        return item
      });
    },
    addItem() {
      this.openTab(2)
    },
    editItem(schedule) {
      this.openTab(2, schedule)
    },
    onItemTableClick(schedule) {
      if (!this.checkPermissionOrShowError(PERMISSIONS.SCHEDULE_VIEW)) return
      this.openTab(1, schedule)
    },
    async deleteItem(schedule) {
      let res = await this.delete(API2.SCHEDULE, {
        employeeId: schedule.employeeId,
        path: schedule.scheduleId,
        type: SCHEDULE_ACTION_TYPE.DELETE
      })
      if (res) {
        this.showToast("success", i18n.t("base.notification"), i18n.t("base.deleteSuccessful"))
        this.getItems(this.optionParams)

      }
    },
    async getListFilter() {
      let res = await this.get(API2.DEPARTMENT, null, "filterLoading")
      this.listFilter = res.data?.map(i => ({... i, name: this.shortenText(i.name, 40)}));
      // // Add "All Departments" option at the beginning
      // this.listFilter = [this.allDepartmentsOption, ...res.data];
      // // Set "All Departments" as default selection
      // this.selectedFilter = this.allDepartmentsOption;
    },
    customFilter() {
      this.getItems(this.optionParams)
    },
    openImportDialog() {
      this.showImportDialog = true;
    },
    onImported() {
      this.showImportDialog = false;
      this.getItems(this.optionParams);
      this.showToast("success", i18n.t("base.notification"), i18n.t("schedule.importSuccess"));
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
  },
  computed: {
    isCreate() {
      return this.hasPermission(PERMISSIONS.SCHEDULE_CREATE)
    },
    isEdit() {
      return this.hasPermission(PERMISSIONS.SCHEDULE_UPDATE)
    },
    isDelete() {
      return this.hasPermission(PERMISSIONS.SCHEDULE_DELETE)
    },
    fields() {
      const baseFields = [
        {value: "name", text: i18n.t("schedule.employee")},
        {value: "time", text: i18n.t("schedule.time"), sortable: false},
        {value: "date", text: i18n.t("schedule.date"), sortable: false},
        {value: "day", text: i18n.t("schedule.day"), sortable: false}
      ];
      
      if (this.isEdit || this.isDelete) {
        baseFields.push({value: "actions", sortable: false});
      }
      
      return baseFields;
    },
  },
}
;
</script>

<style>

.btn-custom-import {
  height: 40px !important;
}

</style>
